// extracted by mini-css-extract-plugin
module.exports = {"main":"myButton_main__38CWG","primary":"myButton_primary__1S0N-","disabled":"myButton_disabled__3_Zbx","secondary":"myButton_secondary__1BkbW"};